export default __webpack_public_path__ + "static/media/new.91fc0bdc.png";